import React from 'react';
import cx from 'classnames';
import { Button, Loader, Icon } from '@hometap/htco-components';

import './Callout.scss';

type CalloutType = 'info' | 'error' | 'warning' | 'success' | 'neutral';

// Map the type to corresponding icon names
const ICON_MAP: Record<CalloutType, string> = {
  info: 'icon-info',
  warning: 'icon-alert',
  error: 'icon-error',
  success: 'icon-check-mdc',
  neutral: 'icon-list',
};

interface CalloutProps {
  children: React.ReactNode;
  type: CalloutType;
  actionIcon?: string;
  actionLabel?: string;
  onPress?: () => void;
  className?: string;
  hideIcon?: boolean;
  loading?: boolean;
}

const Callout: React.FC<CalloutProps> = ({
  children,
  type,
  actionIcon,
  actionLabel,
  onPress,
  className,
  hideIcon,
  loading,
}) => {
  return (
    <span className={cx('Callout', type, className)}>
      {!hideIcon && <Icon name={ICON_MAP[type]} />}
      <span className="Callout-content">{children}</span>
      {actionLabel && onPress && (
        <div className="Callout-ActionArea">
          {loading ? (
            <Loader />
          ) : (
            <Button icon={actionIcon} theme="link" onClick={onPress}>
              {actionLabel}
            </Button>
          )}
        </div>
      )}
    </span>
  );
};

export default Callout;
